import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

export default new VueRouter({
    routes: [{
        path: '/Index',
        component: () =>
            import ('../common/Index.vue'),
        children: [{
                path: '/Index/Home',
                component: () =>
                    import ('../views/Home.vue')
            }, {
                path: '/Index/XinWen',
                component: () =>
                    import ('../views/XinWen.vue')
            },
            {
                path: '/Index/GongYi',
                component: () =>
                    import ('../views/GongYi.vue')
            },
            {
                path: '/Index/DangJian',
                component: () =>
                    import ('../views/DangJian.vue')
            },
            {
                path: '/Index/ZhengCe',
                component: () =>
                    import ('../views/ZhengCe.vue')
            },
            {
                path: '/Index/LiShi',
                component: () =>
                    import ('../views/LiShi.vue')
            },
            {
                path: '/Index/GuanYu',
                component: () =>
                    import ('../views/GuanYu.vue')
            },
            {
                path: '/Index/DocInfo',
                component: () =>
                    import ('../views/DocInfo.vue')
            },
            {
                path: '/Index/DocList',
                component: () =>
                    import ('../views/DocList.vue')
            },

        ]
    }, ]
});